export default {
  title: ['Nom du lieu', 'Name of the place'],
  address: ['Adresse', 'Address'],
  itinerary: ["Proposer l'itinéraire", 'Propose the route'],
};
